"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transformAgendaOverview_1 = require("./transformAgendaOverview");
var transformClinicAvailability = function (data) {
    var entries = data.map(function (item) {
        var clinic = item.clinic.length ? item.clinic[0] : false;
        if (clinic) {
            // eslint-disable-next-line camelcase
            var id = item.id, start_date = item.start_date, end_date = item.end_date;
            return {
                id: id,
                name: clinic.name || 'Niet beschikbaar',
                sport: clinic.sport || 'Niet beschikbaar',
                type: (clinic.type && transformAgendaOverview_1.clinicType(clinic.type)) || 'Niet beschikbaar',
                start_date: start_date,
                end_date: end_date,
            };
        }
    });
    return entries;
};
exports.default = transformClinicAvailability;
